module.exports = "/images/amex.svg";